<template>
  <div>
    <bfheader></bfheader>
    <div class="main-content mt-2">
      <div class="header">
        <b-alert variant="info" :show="message != null">{{message}}</b-alert>
        <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
      </div>
      <div class="container-fluid">
        <div class="p-2 border-bottom border-info">
          <h4 class="text-info font-italic">
            <strong>測定会一覧</strong>
            <span class="ml-2"><button class="btn btn-info" @click="loadItems"><i class="fas fa-sync"/> 再読込</button></span>
            <span class="ml-2"><button class="btn btn-warning" @click="showRegisterModal"><i class="fas fa-plus"/> 新規登録</button></span>
          </h4>
        </div>
        <div>
          <v-client-table :columns="table.columns" :data="userGroups" :options="table.options" class="usergroups-table">
            <a slot="groupId" slot-scope="props">
              <b-btn variant="link" size="sm" @click.prevent="goUserGroup(props.row)"><b>{{props.row.groupId}}</b></b-btn>
            </a>
            <a slot="buttons" slot-scope="props">
              <span v-if="!props.row.allowedAt || props.row.closedAt">
                <b-btn size="sm" variant="success" @click="onUserGroupOpened(props.row)">
                  <i class="fas fa-lock-open"></i>
                </b-btn>
              </span>
              <span v-else>
                <b-btn size="sm" variant="warning" @click="onUserGroupClosed(props.row)">
                  <i class="fas fa-lock"></i>
                </b-btn>
              </span>
              <span v-if="props.row.closedAt">
                <b-btn size="sm" variant="none" disabled>
                  <i class="fas fa-trash"></i>
                </b-btn>
              </span>
              <span v-else>
                <b-btn size="sm" variant="danger" @click="onDelete(props.row)">
                  <i class="fas fa-trash"></i>
                </b-btn>
              </span>
            </a>
            <a slot="actionStatus" slot-scope="props">
              {{ actionStatus(props.row) }}
            </a>
            <a slot="scheduledAt" slot-scope="props">
              {{ formatScheduledAt(props.row.scheduledAt) }}
            </a>
            <a slot="lastModifiedAt" slot-scope="props">
              {{ formatDateTime(props.row.lastModifiedAt) }}
            </a>
          </v-client-table>
        </div>
      </div>
    </div>

    <bffooter></bffooter>
    <div>
      <b-modal ref="registerModal" title="新規登録"
        header-bg-variant="info"
        header-text-variant="light"
        >
        <b-alert variant="danger" :show="registerError != null">{{registerError}}</b-alert>
        <form @submit.stop.prevent="onRegister">
          <b-form-group label="測定会ID:">
            <b-form-input
                        id="userId"
                        type="text"
                        size="10"
                        v-model.trim="form.groupId"
                        :state="validators.groupId"
                        required
                        placeholder="英数4桁以上 例:H181220">
            </b-form-input>
            <b-form-invalid-feedback id="groupIdFeedback">
              英数4桁以上を入力してください
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="測定名:(場所+日付など)">
            <b-form-input
                        id="name"
                        type="text"
                        size="13"
                        v-model.trim="form.name"
                        :state="validators.name"
                        required
                        placeholder="３文字以上 例：伊勢原岡崎0826">
            </b-form-input>
            <b-form-invalid-feedback id="nameFeedback">
              3文字以上を入力してください
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="開始日時:">
            <b-form-input
                        id="scheduledAtDate"
                        type="date"
                        size="13"
                        v-model="form.scheduledAtDate"
                        :state="validators.scheduledAtDate"
                        required
                        placeholder="開始日時">
            </b-form-input>
            <b-form-input
                        id="scheduledAtTime"
                        type="time"
                        size="13"
                        v-model="form.scheduledAtTime"
                        :state="validators.scheduledAtTime"
                        required
                        placeholder="開始日時">
            </b-form-input>
            <b-form-invalid-feedback id="scheduledAtTimeFeedback">
              日時を選択してください
            </b-form-invalid-feedback>
          </b-form-group>
        </form>
        <div slot="modal-footer" class="w-100">
          <b-btn variant="primary" @click="onRegister">
           登録
          </b-btn>
          <b-btn variant="link" @click="onClose">
           閉じる
          </b-btn>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { Logger } from 'aws-amplify'
import Vue from 'vue'
import moment from 'moment-timezone'
import { ClientTable } from 'vue-tables-2'

import bfheader from '@/components/BfHeader'
import bffooter from '@/components/BfFooter'

const logger = new Logger('UserGroups')
const STATUS = { YET: '未定', NOT_ALLOW: '未許可', ACCEPT: '受付中', POSTED: '実施済', CLOSED: '終了', UNKNOWN: '不明' }
Vue.use(ClientTable)

export default {
  name: 'UserGroups',
  components: {
    bfheader,
    bffooter
  },
  data () {
    return {
      loading: false,
      message: null,
      error: null,
      registerError: null,
      form: {
        groupId: null,
        name: null,
        scheduledAt: null,
        scheduledAtDate: null,
        scheduledAtTime: null
      },
      validators: {
        groupId: null,
        name: null,
        scheduledAt: null,
        scheduledAtDate: null,
        scheduledAtTime: null
      },
      userGroups: this.$store.getters.userGroups,
      table: {
        columns: [
          'groupId', 'name', 'actionStatus', 'scheduledAt', 'lastModifiedAt', 'buttons'
        ],
        options: {
          headings: {
            groupId: '測定会ID',
            name: '店舗/測定会名',
            actionStatus: '状態',
            scheduledAt: '実施日付',
            lastModifiedAt: '更新日時',
            buttons: '操作'
          },
          sortable: [ 'groupId', 'actionStatus', 'scheduledAt' ],
          sortIcon: {
            base: 'fas', up: 'fa-arrow-up', down: 'fa-arrow-down', is: 'fa-sort'
          },
          orderBy: {
            column: 'groupId',
            ascending: true
          }
        }
      }
    }
  },
  mounted () {
    this.loadItems()
  },
  methods: {
    formatScheduledAt (time) {
      return moment(time, 'YYYYMMDDHHmmssSSS').format('YYYY/MM/DD HH:mm')
    },
    formatDate (time) {
      return moment(time, 'x').format('YYYY/MM/DD HH:mm')
    },
    formatDateTime (time) {
      return moment(time, 'x').format('YYYY/MM/DD HH:mm:ss')
    },
    actionStatus (act) {
      if (!act) return STATUS.UNKNOWN
      if (!act.allowedAt) return STATUS.NOT_ALLOW
      if (act.closedAt) return STATUS.CLOSED
      return (!act.postedAt) ? STATUS.ACCEPT : STATUS.POSTED
    },
    loadItems () {
      this.message = null
      this.error = null
      return new Promise((resolve) => {
        setTimeout(() => {
          return this.$store.dispatch('fetchUserGroups').then((userGroups) => {
            this.userGroups = userGroups
          }).catch(err => {
            logger.error(err)
            this.error = err.message || err
          })
        }, 1000)
      })
    },
    refreshItems () {
      this.loadItems()
    },
    goUserGroup (userGroup) {
      this.$router.push('/usergroups/' + userGroup.groupId + '/top')
    },
    validate () {
      this.validators.groupId = this.form.groupId && /^[A-z0-9]{3,}$/.test(this.form.groupId) ? true : false
      this.validators.name = this.form.name ? true : false
      this.validators.scheduledAtDate = this.form.scheduledAtDate ? true : false
      this.validators.scheduledAtTime = this.form.scheduledAtTime ? true : false
      return ['groupId', 'name', 'scheduledAtDate', 'scheduledAtTime'].every(p => this.validators[p])
    },
    onRegister () {
      this.error = null
      this.message = null
      logger.debug(this.form)
      if (!this.validate()) {
        logger.debug(this.validators)
        return
      }
      let newData = Object.assign({}, this.$data.form)
      newData.scheduledAt = moment(newData.scheduledAtDate + 'T' + newData.scheduledAtTime).format('YYYYMMDDHHmmssSSS')
      this.loading = true
      return this.$store.dispatch('createUserGroup', { newGroup: newData }).then(() => {
        this.loading = false
        this.message = '登録しました'
        this.form = {
          groupId: null,
          name: null,
          scheduledAt: null,
          scheduledAtDate: null,
          scheduledAtTime: null
        }
        this.validators = {
          groupId: null,
          name: null,
          scheduledAt: null,
          scheduledAtDate: null,
          scheduledAtTime: null
        }
        this.$refs.registerModal.hide()
        this.refreshItems()
      }).catch(err => {
        this.loading = false
        logger.error(err)
        this.registerError = err.message || err
      })
    },
    showRegisterModal () {
      this.$refs.registerModal.show()
    },
    onUserGroupOpened (userGroup) {
      if (!userGroup) return
      this.loading = true
      this.message = null
      this.error = null
      return this.$store.dispatch('openUserGroup', { groupId: userGroup.groupId }).then(() => {
        this.loading = false
        this.message = '終了しました'
        this.refreshItems()
      }).catch(err => {
        this.loading = false
        logger.error(err)
        this.error = err.message || err
      })
    },
    onUserGroupClosed (userGroup) {
      logger.debug(userGroup)
      if (!userGroup) return
      this.loading = true
      this.message = null
      this.error = null
      return this.$store.dispatch('closeUserGroup', { groupId: userGroup.groupId }).then(() => {
        this.loading = false
        this.message = '終了しました'
        this.refreshItems()
      }).catch(err => {
        this.loading = false
        logger.error(err)
        this.error = err.message || err
      })
    },
    onDelete (userGroup) {
      if (!userGroup) {
        return
      }
      if (!window.confirm('本当に削除しますか？')) {
        return
      }
      this.loading = true
      this.message = null
      this.error = null
      return this.$store.dispatch('deleteUserGroup', { groupId: userGroup.groupId }).then(() => {
        this.loading = false
        this.message = '削除しました'
        this.refreshItems()
      }).catch(err => {
        this.loading = false
        logger.error(err)
        this.error = err.message || err
      })
    },
    showModal (userGroup, step) {
      this.currentUser = userGroup
      this.$refs.preEnqueteModal.showModal(userGroup)
    },
    onClose () {
      this.$refs.registerModal.hide()
    }
  }
}
</script>

<style scoped>
.step-table, .usergroups-table {
  font-size: 0.75rem;
}
</style>
